import React, { useEffect, useState } from 'react'
import { Table, Button, Modal, Input, Space } from 'antd'
import { PlusOutlined, EditOutlined, DeleteOutlined, SlackOutlined } from '@ant-design/icons'
import {
  CreateCityDataAPI,
  DeleteCityDataAPI,
  GetCityDataAPI,
  UpdateCityDataAPI,
} from '../../AllAPI/AdminAPI'
import axiosInstance from '../../Utils/axiosInstance'
import { toast } from 'react-toastify'

const CityMaster = () => {
  const [cities, setCities] = useState([])
  const [searchText, setSearchText] = useState('')
  const [loading, setLoading] = useState(false)

  // Modal + Inputs
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingId, setEditingId] = useState(null)
  const [cityName, setCityName] = useState('')

  // Delete
  // const [deleteId, setDeleteId] = useState(null)

  useEffect(() => {
    fetchCities()
  }, [])

  /* ================= Fetch ================= */
  const fetchCities = async () => {
    setLoading(true)
    try {
      const res = await axiosInstance.get(GetCityDataAPI)
      setCities(Array.isArray(res.data) ? res.data : [])
    } catch {
      toast.error('Failed to load cities')
    } finally {
      setLoading(false)
    }
  }

  /* ================= Open Modal ================= */
  const openModal = (record = null) => {
    if (record) {
      setEditingId(record.id)
      setCityName(record.city_name)
    } else {
      setEditingId(null)
      setCityName('')
    }
    setIsModalOpen(true)
  }

  /* ================= Save / Update ================= */
  const handleSave = async () => {
    if (!cityName.trim()) {
      return toast.error('City name is required')
    }

    const objData = {
      city_name: cityName,
    }

    try {
      if (editingId) {
        const res = await axiosInstance.put(
          `${UpdateCityDataAPI}/${editingId}`,
          objData,
        )
        if (res.data === 'UPDATED') toast.success('City Updated')
      } else {
        const res = await axiosInstance.post(CreateCityDataAPI, objData)
        if (res.data === 'SAVED') toast.success('City Added')
      }

      fetchCities()
      setIsModalOpen(false)
      setEditingId(null)
      setCityName('')
    } catch {
      toast.error('Failed to save city')
    }
  }

  /* ================= Delete ================= */
  // const confirmDelete = async () => {
  //   try {
  //     await axiosInstance.delete(`${DeleteCityDataAPI}/${deleteId}`)
  //     toast.success('City deleted')
  //     fetchCities()
  //   } catch {
  //     toast.error('Delete failed')
  //   } finally {
  //     setDeleteId(null)
  //   }
  // }

  /* ================= Search ================= */
  const filteredCities = cities.filter((c) =>
    c.city_name?.toLowerCase().includes(searchText.toLowerCase()),
  )

  /* ================= Table ================= */
  const columns = [
    { title: 'City Name', dataIndex: 'city_name' },
    {
      title: 'Actions',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            size="small"
            onClick={() => openModal(record)}
          />
          {/* <Button
            icon={<DeleteOutlined />}
            size="small"
            danger
            onClick={() => setDeleteId(record.id)}
          /> */}
        </Space>
      ),
    },
  ]

  return (
    <>
      <div className="mainContainer">
        <div className="header-row">
          <h3><SlackOutlined style={{ color: 'orangered' }} /> City Master</h3>
        </div>

        <div className="search-bar text-end">
          <Button
            className="addButton mx-md-2"
            icon={<PlusOutlined />}
            onClick={() => openModal()}
          >
            Add
          </Button>
          <Input
            placeholder="Search city..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 250 }}
          />
        </div>

        <Table
          columns={columns}
          dataSource={filteredCities}
          rowKey="id"
          loading={loading}
          bordered
          className='shadow'
           style={{overflowX:"auto"}}
        />
      </div>

      {/* ================= MODAL ================= */}
      <Modal
        title={editingId ? 'Edit City' : 'Add City'}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsModalOpen(false)}>
            Cancel
          </Button>,
          <Button key="save" type="primary" onClick={handleSave}>
            {editingId ? 'Update' : 'Save'}
          </Button>,
        ]}
      >
        <label>City Name</label>
        <Input
          value={cityName}
          onChange={(e) => setCityName(e.target.value)}
          placeholder="Enter city name"
        />
      </Modal>

      {/* ================= DELETE ================= */}
      {/* <Modal
        title="Confirm Delete"
        open={!!deleteId}
        onCancel={() => setDeleteId(null)}
        onOk={confirmDelete}
        okText="Delete"
        okButtonProps={{ danger: true }}
      >
        Are you sure you want to delete this city?
      </Modal> */}
    </>
  )
}

export default CityMaster
